import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { useSelector } from 'react-redux';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import axios from 'axios';
// import Button from '@material-ui/core/Button';
// import TextField from '@material-ui/core/TextField';
// import CircularProgress from '@material-ui/core/CircularProgress';
// import Snackbar from '@material-ui/core/Snackbar';
// import Alert from '@material-ui/lab/Alert';
// import DateFnsUtils from '@date-io/date-fns';
import { Card, CardContent, makeStyles } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
// import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { Multiselect } from 'multiselect-react-dropdown';
import ButtonComp from '../../components/button';
import { CommonConfig } from '../../config/common-config';
import './servicestyles.css';
import LoaderPopUp from '../../components/loaderpopup/loader';
import SuccessPopUp from '../../components/loaderpopup/success';
import ErrorPopUp from '../../components/loaderpopup/error';
// import moment from 'moment';
import token from '../../config/token';

const useStyles = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
    },
    bottomLine: {
        borderBottom: '1px solid #ccc !important',
    },
    margn: {
        marginTop: '6px !important',
    },
});

export default function UpdateServices(props) {
    const location = useLocation();
    const classes = useStyles();
    // const history = useHistory();
    const tokens = token();

    const service = location.state.row;
    const assigneeJson = JSON.parse(props.location.state.row.assigneeJson);
    const selectedAssigne = (assigneeJson) => {
        const OptionList = assigneeJson.map((data) => ({ name: `${data.id} - ${data.name}`, id: data.id }));
        return OptionList;
    };
    const selectedValue = selectedAssigne(assigneeJson);
    const [selectedDate, handleDateChange] = useState(service.serviceYear);
    const [allServices, setAllServices] = useState([]);
    // const [deleteService, setUpdateService] = useState([]);
    const servicetypeid = location.state.row.servicetypeId;
    const [selectedImcCoreName, setSelectedImcCoreName] = useState('');
    // const [selectedImcCoreName1, setSelectedImcCoreName1] = useState('');
    const [coreTeam, setCoreTeam] = useState([]);
    const [showBtnLoader, setShowBtnLoader] = useState(false);
    // const [updateStat, setUpdateStat] = useState(false);
    // const [assignee, setAssignee] = useState('Assignee of Team member');
    // const [selectAssign, selectedAssignee] = useState([]);
    const [assigneeArr, setAssigneeArr] = useState(assigneeJson);
    // const [selectedType, setselectedType] = useState('');
    // const vertical = 'top';
    // const horizontal = 'center';
    // const tennantDetails = useSelector((state) => state.loginsuccessreducer.tennantName);
    const dbname = useSelector((state) => state.serviceCheckListReducer.imcNameSelected);
    const [successpop, setSuccessPop] = useState(false);
    const [errorpop, setErrorPop] = useState(false);
    const [errorMsgGenerateRecceipt, setErrorMsgGenerateRecceipt] = useState('');
    const servicetype = location.state.row.servicetypeId.servicetypeText;
    const userDetails = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails);
    const usertype = userDetails.result && userDetails.result.data.userType;

    const handleClose = () => {
        setShowBtnLoader(false);
    };

    //format date function
    function reformatDateString(s) {
        var b = s.split(/\D/);
        return b.reverse().join('-');
    }

    const formik = useFormik({
        initialValues: {
            ultimateclient: service.clientType,
            servicetype: servicetypeid.servicetypeText,
            // servicetype: location.state.row.servicetypeId.servicetypeText,
            firstAssignee: selectedValue,
            // secondAssignee: service.secondAssignee,
            // coreteam: service.assignTo,
            description: service.description,
            serviceId: service.serviceId,
            clientId: service.clientId,
            year: service.serviceYear,
            startdate: reformatDateString(service.startDate),
            tentativedate: service.tentativeClosedate,
            scopeOfAudit: service.servicetypeId.servicetypeText,
            // ultimateclientname: service.clientName
            // assignee:selectAssign,
        },
        validationSchema: Yup.object().shape({
            ultimateclient: Yup.string().required('Required '),
            servicetype: Yup.string().required('Required '),
            scopeOfAudit: Yup.string().required('Required '),
            // coreteam: Yup.string().required('Required Field'),
            // ultimateclientname: Yup.string().required('Required'),
            year: Yup.date().required('Required'),
            // firstAssignee: Yup.string().required('Required'),
            // secondAssignee: Yup.string().required('Required'),
            startdate: Yup.date().required('Required'),
            tentativedate: Yup.date().min(Yup.ref('startdate'), "tentative date can't be before start date").required('Invalid Date '),
            description: Yup.string().required('Required '),
            clientId: Yup.date().required('Required'),
            serviceId: Yup.date().required('Required'),
        }),
        onSubmit: (values) => {
            let newassignee = '';
            setShowBtnLoader(true);
            //console.log(assigneeArr.length);
            if (assigneeArr.length < 1) {
                //console.log(assigneeJson);
                newassignee = assigneeJson;
            } else {
                newassignee = assigneeArr;
            }
            const data = {
                clientType: values.ultimateclient,
                servicetypeId: {
                    servicetypeId: service.servicetypeId.servicetypeId,
                    servicetypeText: service.servicetypeId.servicetypeText,
                },
                // clientName: values.ultimateclientname,
                clientId: values.clientId,
                serviceYear: values.year,
                startDate: values.startdate,
                tentativeClosedate: values.tentativedate,
                description: values.description,
                // assignTo: values.coreteam,
                assignees: newassignee,
                // secondAssignee: values.secondAssignee,
                statusId: {
                    statusId: 1,
                    servicetypeText: 'inprogress',
                },
                createdBy: service.createdBy,
                modified_by: service.createdBy,
                serviceId: values.serviceId,
                scopeOfAudit: values.scopeOfAudit,
            };
            //console.log("data", data);

            axios
                .put(`${CommonConfig.dev.baseUrl}/api/auth/createservice-employee/${dbname}`, data, tokens)
                .then((response) => {
                    if (response.status === 200) {
                        setShowBtnLoader(false);
                        setSuccessPop(true);
                        setTimeout(() => {
                            usertype === 'SUPERADMIN' ?
                                props.history.push({
                                    pathname: '/menu/openserviceall',
                                    state: { domainname: location.state.selectedImc },
                                })
                                :
                                props.history.push({
                                    pathname: '/menu/openservice',
                                });
                        }, 3000);
                    }
                })
                .catch((error) => {
                    //console.log(error);
                    const errResult = error.response;
                    if (errResult.data) {
                        setShowBtnLoader(false);
                        setErrorPop(true);
                        setTimeout(() => {
                            setErrorPop(false);
                        }, 5000);
                        setErrorMsgGenerateRecceipt(errResult.data.message);
                    }
                });
        },
    });

    // const navigate = () => {
    //     props.history.push('/menu/IMCView');
    // };

    // get Date
    // const getDate = (e) => {
    //     //console.log(e, "Get Date");
    //     handleDateChange(e);
    // };

    // const allCoreTeamOptions = (allcoreteam) => {
    //     //console.log("allcoreteam", allcoreteam);
    //     const OptionList = allcoreteam.map((data) => (
    //         <option value={data.empId} key={data.empId}>
    //             {data.empId} - {data.firstName}
    //         </option>
    //     ));
    //     return OptionList;
    // };

    const allCoreTeamMultiOptions = (allcoreteam) => {
        // const tempEmployee = allcoreteam;
        // allcoreteam = [];
        // tempEmployee.map((ele, i) => {
        //     if (ele.officeEmail != tennantDetails.userName) {
        //         allcoreteam.push(ele);
        //     }
        // })
        console.log(allcoreteam);
        const OptionList = allcoreteam.map((data) => ({ name: `${data.empId} - ${data.firstName} ${data.lastName}`, id: data.empId }));
        return OptionList;
    };

    // const getAssignees = (assigneeJson) => {
    //     const assignees = assigneeJson.map((data) => data.name);
    //     return assignees;
    //     //console.log(assigneeJson);
    //     // return 'hi';
    // };

    // const allServicesOptions = (servicestype) => {
    //     //console.log("servicestype", servicestype);
    //     const OptionList = servicestype.map((data) => <option value={data.servicetypeId}> {data.servicetypeText}</option>);
    //     return OptionList;
    // };

    const setCoreTeamNames = (e) => {
        setSelectedImcCoreName(e.id);
        //console.log("setCoreTeamNames", e.target.value);
    };
    // const setCoreTeamNames1 = (e) => {
    //     setSelectedImcCoreName1(e.target.value);
    //     //console.log("setCoreTeamNames1", e.target.value);
    // };

    // const setType = (e) => {
    //     setselectedType(e.target.value);
    //     // setIsDisableAddFile(false);
    //     //console.log("setType", e.target.value);
    // };

    useEffect(() => {
        ////console.log('start', formik.values)

        // const selectedImc = location.state.selectedImc;

        axios
            .get(`${CommonConfig.dev.baseUrl}/api/auth/get-cs-servicetype/${dbname}`, tokens)
            .then((response) => {
                setAllServices(response.data);
            })
            .catch((error) => {
                //console.log(error);
            });

        axios
            .get(`${CommonConfig.dev.baseUrl}/api/auth/intClient-employee/${dbname}?page=0&size=1000&sort=empId,desc`, tokens)
            .then((response) => {
                ////console.log("response", response.data.content);
                setCoreTeam(response.data.content);
            });
        selectedAssigne(assigneeJson);
    }, [dbname, tokens]);

    //console.log("formik values",formik.values);
    //console.log("Selected Date" , selectedDate)
    const onSelect = (selectedList, selectedItem) => {
        let assignees = coreTeam.filter(function (item) {
            return item.empId === selectedItem.id;
        });
        const aArr = {
            id: assignees[0].empId,
            emailId: assignees[0].officeEmail,
            // name: assignees[0].firstName,
            name: assignees[0].firstName + ' ' + assignees[0].lastName,
            phoneNumber: assignees[0].mobileNumber,
        };
        setAssigneeArr([...assigneeArr, aArr]);
        setCoreTeamNames(selectedItem);
    };
    const onRemove = (selectedList, removedItem) => {
        assigneeArr.filter(function (item, index) {
            if (item.id === removedItem.id) {
                return assigneeArr.splice(index, 1);
            }
        });
        setAssigneeArr([...assigneeArr]);
    };
    // const handleSel = (e) => {
    //     //console.log("sel val", assignee +', '+ e.target.value);
    //     let val = assignee === 'Assignee of Team member' ? e.target.value : assignee + ', ' + e.target.value;
    //     val = val.toString();
    //     setAssignee(val);
    //     const assignees = coreTeam.filter(function (item) {
    //         return item.empId === e.target.value;
    //     });
    //     const aArr = {
    //         id: assignees[0].empId,
    //         emailId: assignees[0].officeEmail,
    //         name: assignees[0].firstName,
    //     };
    //     setAssigneeArr([...assigneeArr, aArr]);
    //     setCoreTeamNames(e);
    //     //console.log("assigneeArr", assigneeArr);
    // };

    const getYearDate = (e) => {
        ////console.log(e.target.value, 'Get Date');
        handleDateChange(e.target.value);
        formik.values.year = e.target.value;
    };

    const getFinancialYearList = () => {
        //console.log('dropdownIndex,travelOutSide',dropdownIndex,travelOutSide)
        //console.log(dropdownIndex);
        const CurentYear = new Date().getFullYear();
        const minYear = CurentYear - 2;
        const maxYear = CurentYear + 200;
        const options = [];
        for (let i = minYear; i <= maxYear; i++) {
            const optioValues = `${i}-${(i + 1).toString().substr(-2)}`;
            options.push(
                <option value={optioValues}>
                    {i}-{(i + 1).toString().substr(-2)}
                </option>
            );
        }
        return options;
    };

    return (
        <>
            {/* <Snackbar
                className="deleteError"
                open={updateStat}
                anchorOrigin={{ vertical, horizontal }}
                autoHideDuration={3000}
                onClose={() => {
                    setUpdateStat(false);
                }}
            >
                <Alert
                    onClose={() => {
                        setUpdateStat(false);
                    }}
                >
                    Service updated successfully
                </Alert>
            </Snackbar> */}

            {successpop ? (
                <SuccessPopUp open={successpop} showSuccess={successpop} handleClose={handleClose} title="Service updated successfully" />
            ) : null}
            {errorpop ? (
                <ErrorPopUp open={errorpop} showError={errorpop} handleClose={handleClose} title={errorMsgGenerateRecceipt} />
            ) : null}

            <form className="itecform" onSubmit={formik.handleSubmit}>
                <Card className="clientcard">
                    <CardContent className="client-heading">
                        <Typography variant="h5">Update Service</Typography>
                    </CardContent>
                    <CardContent>
                        <Grid container spacing={3} className="main-container">
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="serviceId" shrink>
                                        {' '}
                                        Service ID
                                    </InputLabel>
                                    <Input
                                        type="text"
                                        className="bottom"
                                        placeholder="Service ID"
                                        disabled
                                        name="serviceId"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.serviceId}
                                    />
                                    {formik.touched.serviceId && formik.errors.serviceId ? (
                                        <span className="itec-validationError">{formik.errors.serviceId}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="clientId" shrink>
                                        {' '}
                                        Client ID
                                    </InputLabel>
                                    <Input
                                        type="text"
                                        className="bottom"
                                        disabled
                                        name="clientId"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.clientId}
                                    />
                                    {formik.touched.clientId && formik.errors.clientId ? (
                                        <span className="itec-validationError">{formik.errors.clientId}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="ultimateclient" shrink>
                                        {' '}
                                        Type of client
                                    </InputLabel>
                                    <Select
                                        native
                                        name="ultimateclient"
                                        disabled
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.ultimateclient}
                                        className="bottom"
                                    >
                                        <option value="">Type of client</option>
                                        {}
                                        <option value="Individual">Individual</option>
                                        <option value="Corporate">Corporate</option>
                                    </Select>
                                    {formik.touched.ultimateclient && formik.errors.ultimateclient ? (
                                        <span className="serviceformError">{formik.errors.ultimateclient}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="servicetype" shrink>
                                        {' '}
                                        Type of Service
                                    </InputLabel>
                                    <Input
                                        type="text"
                                        className="bottom"
                                        disabled
                                        name="servicetype"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.servicetype}
                                    />
                                    {formik.touched.servicetype && formik.errors.servicetype ? (
                                        <span className="serviceformError">{formik.errors.servicetype}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            {servicetype === 'AUDIT' ? (
                                <Grid item xs={12} sm={6} className={classes.margn}>
                                    <FormControl fullWidth>
                                        <InputLabel className="lbl" htmlFor="scopeOfAudit" shrink>
                                            Scope of Audit
                                        </InputLabel>
                                        <Input
                                            type="text"
                                            className="bottom"
                                            disabled
                                            name="scopeOfAudit"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.scopeOfAudit}
                                        />
                                        {formik.touched.scopeOfAudit && formik.errors.scopeOfAudit ? (
                                            <span className="serviceformError">{formik.errors.scopeOfAudit}</span>
                                        ) : null}
                                    </FormControl>
                                </Grid>
                            ) : (
                                    ''
                                )}
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    {/* <label className="labelCls">Year</label> */}
                                    <InputLabel className="lbl" htmlFor="year" shrink>
                                        Financial Year
                                    </InputLabel>{' '}
                                    <div className={classes.root}>
                                        {/* <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                            <KeyboardDatePicker
                                                disableToolbar
                                                autoOk
                                                variant="inline"
                                                views={['year']}
                                                placeholder="Select a Year"
                                                className={classes.bottomLine}
                                                name="year"
                                                format="yyyy"
                                                onChange={(e) => {
                                                    getDate(e);
                                                    formik.setFieldValue('year', e.getFullYear());
                                                }}
                                                value={selectedDate}
                                                onBlur={formik.handleBlur}
                                                renderInput={(renderProps) => <TextField {...renderProps} />}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                        </MuiPickersUtilsProvider> */}
                                        <Select
                                            native
                                            name="year"
                                            disabled
                                            className="bottom"
                                            placeholder="Select a Year"
                                            onChange={(e) => {
                                                getYearDate(e);
                                                formik.handleChange(e.target.value);
                                            }}
                                            value={selectedDate}
                                            onBlur={formik.handleBlur}
                                        >
                                            <option value="">Please Select</option>
                                            {getFinancialYearList()}
                                            {/* <option value="2020">2020</option>
                                                                                                    <option value="2021">2021</option>
                                                                                                    <option value="2022">2022</option> */}
                                        </Select>
                                    </div>
                                    {formik.touched.year && formik.errors.year ? (
                                        <span className="serviceformError">{formik.errors.year}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} className={classes.margn}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="description" shrink>
                                        {' '}
                                        Description
                                    </InputLabel>
                                    <Input
                                        type="text"
                                        className="bottom"
                                        name="description"
                                        placeholder="Description"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.description}
                                    />
                                    {formik.touched.description && formik.errors.description ? (
                                        <span className="itec-validationError">{formik.errors.description}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            {/* <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="secondAssignee" shrink>
                                        {' '}
                                        Second Assignee of Core Team member
                                    </InputLabel>
                                    <Select
                                        native
                                        name="secondAssignee"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.secondAssignee}
                                        className="bottom"
                                    >
                                        <option>Second Assignee of Core Team member</option>
                                        {allCoreTeamOptions(coreTeam)}
                                    </Select>
                                    {formik.touched.secondAssignee && formik.errors.secondAssignee ? (
                                        <span className="serviceformError">{formik.errors.secondAssignee}</span>
                                    ) : null}
                                </FormControl>
                            </Grid> */}
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl " htmlFor="firstAssignee" shrink>
                                        {' '}
                                        Assignee of Team member
                                    </InputLabel>
                                    <Multiselect
                                        options={allCoreTeamMultiOptions(coreTeam)}
                                        selectedValues={formik.values.firstAssignee}
                                        onSelect={onSelect}
                                        onRemove={onRemove}
                                        displayValue="name"
                                        showCheckbox={true}
                                        closeOnSelect={false}
                                        placeholder=""
                                        limitTags={2}
                                        showArrow={true}
                                    />
                                    {formik.touched.firstAssignee && formik.errors.firstAssignee ? (
                                        <span className="serviceformError">{formik.errors.firstAssignee}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="startdate" shrink>
                                        {' '}
                                        Start Date
                                    </InputLabel>
                                    {/* <Input
                                        type="date"
                                        className="bottom"
                                        disabled
                                        name="startdate"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.startdate}
                                        inputProps={{ max: "9999-12-31" }}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    /> */}
                                    <Input
                                        type="date"
                                        className="bottom"
                                        name="startdate"
                                        disabled
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.startdate}
                                        inputProps={{ max: '9999-12-31' }}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                    {formik.touched.startdate && formik.errors.startdate ? (
                                        <span className="serviceformError">{formik.errors.startdate}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="tentativedate" shrink>
                                        {' '}
                                        Tentative close date
                                    </InputLabel>
                                    <Input
                                        type="date"
                                        className="bottom"
                                        name="tentativedate"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.tentativedate}
                                        inputProps={{ max: '9999-12-31' }}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                    {formik.touched.tentativedate && formik.errors.tentativedate ? (
                                        <span className="serviceformError">{formik.errors.tentativedate}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
                <div className="createintermediary-btndiv">
                    {/* {(showBtnLoader && (
                        <Button variant="outlined" className="butn butnImp" disabled>
                            <CircularProgress size={20} />
                        </Button>
                    )) || <ButtonComp type="submit" className="intermediarybutn" title="Update Service" />} */}
                    {(showBtnLoader ? (
                        <LoaderPopUp
                            showLoader={showBtnLoader}
                            handleClose={handleClose}
                            title="Please wait while we update your service"
                        />
                    ) : null) || <ButtonComp type="submit" className="intermediarybutn" title="Update Service" />}
                </div>
            </form>

            {/* <div className="titletag">
                <h3>UPDATE SERVICE</h3>
            </div>
            <div className="itecformdiv">
                <form className="itecform" onSubmit={formik.handleSubmit}>
                    <div className="itecform-textboxdiv">
                        <div className="itec-textboxes update-inline">
                            <div className="update-service-width">
                                <label className="labelCls">Service ID</label>
                                <input
                                    disabled
                                    type="text"
                                    className="itecInputBox"
                                    name="description"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.serviceId}
                                />
                                {formik.touched.serviceId && formik.errors.serviceId ? (
                                    <span className="itec-validationError">{formik.errors.serviceId}</span>
                                ) : null}
                            </div>
                            <div className="update-service-width">
                                <label className="labelCls">Client ID</label>
                                <input
                                    disabled
                                    type="text"
                                    className="itecInputBox"
                                    name="description"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.clientId}
                                />
                                {formik.touched.clientId && formik.errors.clientId ? (
                                    <span className="itec-validationError">{formik.errors.clientId}</span>
                                ) : null}
                            </div>
                        </div>

                        <div className="itec-textboxes">
                            <label className="labelCls">Type of client</label>
                            <select
                                className="itecInputBox selectHeight"
                                name="ultimateclient"
                                disabled
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.ultimateclient}
                            >
                                <option value="">Type of client</option>
                                { }
                                <option value="Individual">Individual</option>
                                <option value="Corporate">Corporate</option>
                            </select>

                            {formik.touched.ultimateclient && formik.errors.ultimateclient ? (
                                <span className="serviceformError">{formik.errors.ultimateclient}</span>
                            ) : null}
                        </div>
                        <div className="itec-textboxes">
                            <label className="labelCls">Type of Service</label>
                            <input
                                disabled
                                type="text"
                                className="itecInputBox"
                                name="servicetype"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.servicetype}
                            />
                            {formik.touched.servicetype && formik.errors.servicetype ? (
                                <span className="serviceformError">{formik.errors.servicetype}</span>
                            ) : null}
                        </div>
                        <div className="itec-textboxes">
                            <label className="labelCls">Year</label>
                            <div className={classes.root}>
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <KeyboardDatePicker
                                        disableToolbar
                                        autoOk
                                        variant="inline"
                                        views={['year']}
                                        placeholder="Select a Year"
                                        className="itecInputBox itec-datebox"
                                        name="year"
                                        format="yyyy"
                                        onChange={(e) => {
                                            getDate(e);
                                            formik.setFieldValue('year', e.getFullYear());
                                        }}
                                        value={selectedDate}
                                        onBlur={formik.handleBlur}
                                        renderInput={(renderProps) => <TextField {...renderProps} />}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                </MuiPickersUtilsProvider>
                            </div>
                            {formik.touched.year && formik.errors.year ? (
                                <span className="serviceformError">{formik.errors.year}</span>
                            ) : null}
                        </div>
                        <div className="itec-textboxes">
                            <label className="labelCls">Description</label>
                            <input
                                type="text"
                                placeholder="Description"
                                className="itecInputBox"
                                name="description"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.description}
                            />
                            {formik.touched.description && formik.errors.description ? (
                                <span className="itec-validationError">{formik.errors.description}</span>
                            ) : null}
                        </div>
                        <div className="itec-textboxes">
                            <label className="labelCls">FirstAssignee of Core Team member</label>
                            <select
                                className="itecInputBox selectHeight"
                                name="firstAssignee"
                                type="text"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.firstAssignee}
                            >
                                <option>First Assignee of Core Team member</option>
                                {allCoreTeamOptions(coreTeam)}
                            </select>

                            {formik.touched.firstAssignee && formik.errors.firstAssignee ? (
                                <span className="serviceformError">{formik.errors.firstAssignee}</span>
                            ) : null}
                        </div>
                        <div className="itec-textboxes">
                            <label className="labelCls">SecondAssignee of Core Team member</label>
                            <select
                                className="itecInputBox selectHeight"
                                name="secondAssignee"
                                type="text"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.secondAssignee}
                            >
                                <option>Second Assignee of Core Team member</option>
                                {allCoreTeamOptions(coreTeam)}
                            </select>
                            {formik.touched.secondAssignee && formik.errors.secondAssignee ? (
                                <span className="serviceformError">{formik.errors.secondAssignee}</span>
                            ) : null}
                        </div>
                        <div className="itec-textboxes">
                            <label className="labelCls">Start Date</label>
                            <TextField
                                type="date"
                                disabled
                                className="itecInputBox itec-datebox"
                                name="startdate"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.startdate}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                            {formik.touched.startdate && formik.errors.startdate ? (
                                <span className="serviceformError">{formik.errors.startdate}</span>
                            ) : null}
                        </div>
                        <div className="itec-textboxes">
                            <label className="labelCls">Tentative close date</label>
                            <TextField
                                type="date"
                                className="itecInputBox itec-datebox"
                                name="tentativedate"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.tentativedate}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                            {formik.touched.tentativedate && formik.errors.tentativedate ? (
                                <span className="serviceformError">{formik.errors.tentativedate}</span>
                            ) : null}
                        </div>
                    </div>
                    <div className="createintermediary-btnmaindiv">
                        <div className="createintermediary-btndiv">
                            {(showBtnLoader && (
                                <Button variant="outlined" className="butn" disabled>
                                    <CircularProgress style={{ color: '#F8951B' }} size={20} />
                                </Button>
                            )) || <ButtonComp type="submit" className="butn" title="UPDATE SERVICE" />}
                        </div>
                    </div>
                </form>
            </div> */}
        </>
    );
}
